{
  "auth": {
    "requiredTitle": "Войдите через Telegram",
    "requiredBody": "Откройте это приложение из своего Telegram-бота, чтобы продолжить."
  },
  "navigation": {
    "back": "Назад",
    "home": "Главная",
    "profile": "Профиль"
  },
  "dashboard": {
    "title": "Сервисы",
    "subtitle": "Выберите сервис для продолжения",
    "loading": "Загрузка сервисов...",
    "noServices": "Для этого аккаунта нет активных сервисов.",
    "queryServiceUnavailable": "Запрошенный сервис недоступен для этого аккаунта.",
    "communityLinks": "Ссылки сообщества"
  },
  "services": {
    "ecommerce": {
      "title": "Магазин",
      "description": "Каталог товаров, заказы и отслеживание доставки."
    },
    "marketplace": {
      "title": "Маркетплейс",
      "description": "Объявления, публикация своих товаров и анонимные сообщения."
    },
    "events": {
      "title": "События",
      "description": "Афиша мероприятий и инструкции по навигации к площадкам."
    },
    "digitalMedia": {
      "title": "Магазин цифровых материалов",
      "description": "Курсы, аудио-издания и подписочный обучающий контент."
    },
    "healthBeauty": {
      "title": "Здоровье и красота",
      "description": "Клиники, салоны и специалисты — запишитесь на прием"
    },
    "education": {
      "title": "Образование",
      "description": "Учреждения, репетиторы и честные отзывы сообщества."
    },
    "restaurants": {
      "title": "Рестораны",
      "description": "Рестораны, меню и запросы столиков."
    }
  },
  "staff": {
    "title": "Инструменты персонала",
    "badge": "Управление",
    "ecommerce": {
      "manager": {
        "title": "Управление заказами",
        "description": "Обрабатывайте заказы и доставку"
      }
    },
    "marketplace": {
      "moderator": {
        "title": "Модерация объявлений",
        "description": "Проверяйте и модерируйте объявления"
      }
    },
    "events": {
      "manager": {
        "title": "Менеджер событий",
        "description": "Управляйте своими событиями и локациями"
      }
    },
    "digitalMedia": {
      "manager": {
        "title": "Менеджер Digital Media",
        "description": "Управление курсами и уроками"
      }
    },
    "healthBeauty": {
      "manager": {
        "title": "Стойка клиники",
        "description": "Управляйте сегодняшними записями"
      }
    },
    "education": {
      "manager": {
        "title": "Менеджер образования",
        "description": "Управляйте запросами и отзывами"
      }
    },
    "restaurants": {
      "manager": {
        "title": "Менеджер ресторана",
        "description": "Управляйте меню, запросами столиков и отзывами"
      }
    }
  },
  "errors": {
    "loadServices": "Не удалось загрузить список сервисов. Попробуйте снова."
  },
  "service": {
    "unavailable": "Этот сервис недоступен в этом аккаунте."
  },
  "search": {
    "placeholder": "Поиск по проекту…",
    "results": "Результаты поиска",
    "failed": "Не удалось загрузить результаты. Попробуйте снова.",
    "empty": "Ничего не найдено"
  },
  "trending": {
    "title": "В тренде",
    "swipe": "Листайте →",
    "item1": {
      "badge": "Важно",
      "title": "Обновления правил объявлений"
    },
    "item2": {
      "badge": "События",
      "title": "Встреча специалистов по IT в это воскресенье: регистрация открыта"
    }
  },
  "categories": {
    "title": "Категории",
    "marketplace": "Барахолка",
    "petZone": "Питомцы",
    "services": "Услуги",
    "eventsBot": "Бот событий",
    "shops": "Магазины",
    "digitalMedia": "Цифровые материалы",
    "healthBeauty": "Здоровье и красота",
    "education": "Образование",
    "restaurants": "Рестораны",
    "gifts": "Подарки",
    "news": "Новости",
    "rent": "Аренда"
  },
  "partnership": {
    "title": "Станьте партнёром",
    "subtitle": "Добавьте свой бизнес в нашу экосистему",
    "action": "Подробнее"
  },
  "footer": {
    "home": "Главная",
    "search": "Поиск",
    "favorites": "Избранное",
    "profile": "Профиль"
  },
  "profile": {
    "description": "Ваш аккаунт в этом сообществе.",
    "guest": "Пользователь Telegram"
  }
}
